import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal } from 'react-bootstrap'

import PopupTypes from '../../popup_types'
import { GlgRadio, ClubFeedNotificationCheckbox } from 'SharedComponents'
import { clubFeedChannelsMessage } from '../../../shared/club_feed_channels'
import { clubFeedPopupFields } from '../../column_helpers'

const t = (key) => (window.I18n ? window.I18n.t(key) : '')

const TITLE_ID = 'change_registration_popup_title'

const registrationOptions = (data) => [
  data.openRegistrationStatus !== 'invitation_list' && data.canInvitationsList &&
    { value: 'invitation_list', label: t('leagues.reg_toggle.open_for_invitation_list') },
  data.openRegistrationStatus !== '' &&
    { value: 'closed', label: t('leagues.reg_toggle.closed_for_everyone') },
  data.openRegistrationStatus !== 'open' &&
    { value: 'open', label: t('leagues.reg_toggle.open_for_everyone') },
].filter(Boolean)

const popupQuestion = (key) => t(`customer_center_comp.components.popup_questions.${ key }`)

const confirmMessage = (membershipNames) => [
  `${ popupQuestion('memberships_for_future') } ${ _.join(membershipNames, ', ') }.`,
  popupQuestion('if_continue'),
  '',
  popupQuestion('are_you_sure'),
].join('\n')

const InvitationListRegistrationPopup = ({ show, data, onClose, onSave }) => {
  const [ selected, setSelected ] = useState(null)
  const [ skipNotifications, setSkipNotifications ] = useState(false)

  const options = registrationOptions(data)
  const chosen = selected || (options.length === 1 ? options[0].value : null)
  const clubFeed = clubFeedPopupFields(data)
  const clubFeedMessage = clubFeedChannelsMessage(clubFeed.action, clubFeed.channels, clubFeed.product)

  const handleClose = () => {
    setSelected(null)
    setSkipNotifications(false)
    onClose(PopupTypes.INVITATION_LIST_REGISTRATION)
  }

  const handleSave = () => {
    const removesFutureDates = chosen !== 'closed' && !_.isEmpty(data.futureMembershipProgramsNames)
    if (removesFutureDates && !confirm(confirmMessage(data.futureMembershipProgramsNames))) { // eslint-disable-line no-alert
      return
    }

    onSave(data.leagueId, chosen === 'closed' ? '' : chosen, skipNotifications)
    handleClose()
  }

  return (
    <Modal
      show={ show }
      onHide={ handleClose }
      dialogClassName="club_feed_confirm_popup change_registration_popup"
      aria-labelledby={ TITLE_ID }
    >
      <div className="modal-body">
        <div id="modal_content">
          <div className="change_registration_section">
            <p className="change_registration_warning">{ t('leagues.existing_times.manually_opening') }</p>
            <p className="change_registration_prompt" id={ TITLE_ID }>{ t('leagues.reg_toggle.change_registration_to') }</p>
            <div role="radiogroup" aria-labelledby={ TITLE_ID } className="change_registration_options">
              { options.map(option => (
                <GlgRadio key={ option.value }
                          name="toggle_value"
                          value={ option.value }
                          label={ option.label }
                          defaultChecked={ options.length === 1 }
                          onChange={ setSelected } />
              )) }
            </div>
            { data.canUseMembershipPrograms && (
              <p className="change_registration_dates_link">
                <a href={ data.registrationDatesURL } target="_blank" rel="noopener noreferrer" onClick={ handleClose }>
                  { t('leagues.reg_toggle.view_reg_dates') }
                </a>
              </p>
            ) }
          </div>
          { clubFeedMessage && <p className="club_feed_popup_message">{ clubFeedMessage }</p> }
          <ClubFeedNotificationCheckbox channels={ data.clubFeedChannels }
                                        settingsUrl={ data.clubFeedSettingsUrl }
                                        learnMoreUrl={ data.clubFeedLearnMoreUrl }
                                        checked={ skipNotifications }
                                        onChange={ setSkipNotifications } />
        </div>
        <fieldset className="submit_bar">
          <button type="button"
                  className="btsp_orange_button save_button btn pull-right"
                  disabled={ !chosen }
                  onClick={ handleSave }
          >
            { t('buttons.save') }
          </button>
          <button type="button" className="btn button btsp_gray_button pull-right" onClick={ handleClose }>
            { t('buttons.cancel') }
          </button>
        </fieldset>
      </div>
    </Modal>
  )
}

InvitationListRegistrationPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default InvitationListRegistrationPopup
